import MUIDataTable from 'mui-datatables'
import { Link, withRouter } from 'react-router-dom';
import axiosInstance from '../../../axiosInstance';
import "../../../css/Users.css"
import { containsPermission, logOut } from '../../helper';
import React, {Component} from 'react';
import { Form, Col, ButtonToolbar, ButtonGroup, Button } from 'react-bootstrap';


const boolean_function = (value) => {
    return <input type="checkbox" checked = {value} readOnly />
}

const columns = [
    {
        "name" : "display_name",
        "label" : "ტიპი",
        "options": {
            "sort" : true
        }
    },
    {
        "name" : "is_create_stb",
        "label" : "STB-დადგმა",
        "options": {
            "sort" : true,
            customBodyRender :boolean_function
        }
    },
    {
        "name" : "is_create_internet",
        "label" : "INTERNET-დადგმა",
        "options": {
            "sort" : true,
            customBodyRender :boolean_function
        }
    },
    {
        "name" : "is_remove_stb",
        "label" : "STB-მოხსნა",
        "options": {
            "sort" : true,
            customBodyRender :boolean_function
        }
    },
    {
        "name" : "is_remove_internet",
        "label" : "INTERNET მოხსნა",
        "options": {
            "sort" : true,
            customBodyRender :boolean_function
        }
    },
    {
        "name" : "is_replace_stb",
        "label" : "STB-შეცვლა",
        "options": {
            "sort" : true,
            customBodyRender :boolean_function
        }
    },
    {
        "name" : "is_replace_internet",
        "label" : "INTERNET-შეცვლა",
        "options": {
            "sort" : true,
            customBodyRender :boolean_function
        }
    },

    
]
class Types extends Component {
    constructor(){
        super();
        this.onRowSelectionChange = this.onRowSelectionChange.bind(this);
        this.toolbarSelect = this.toolbarSelect.bind(this)
        this.state = {
            selected_type:null,
            data:[],
            options:{
                filterType: 'checkbox',
                selectableRowsHeader:false,
                expandableRowsHeader:false,
                viewColumns:false,
                print:false,
                filter:false,
                selectableRows:'single',
                onRowSelectionChange:this.onRowSelectionChange,
                customToolbarSelect:this.toolbarSelect,
            },
            response : {
                isValid : false,
                isInValid:false,
                message : 'პრობლემა წარმატებით ჩაემატა'
            }
        }
    }
    componentDidMount(){
        this.fetch_types();
    }

    toolbarSelect(){
        return (
            <ButtonToolbar> 
                    <ButtonGroup  className="mr-2">
                        <Button className = "btn-warning"  onClick = {(e)=>{
                            this.props.history.push("/types/update_type/"+this.state.selected_type)
                        }}>შეცვლა</Button>
                    </ButtonGroup>
                    <ButtonGroup className="mr-2">
                        <Button className = "btn-danger"  onClick = {(e)=>this.delete(this.state.selected_type)}>წაშლა</Button>
                    </ButtonGroup>
            </ButtonToolbar>
        )
    }


    fetch_types(){
        axiosInstance.get('tickets/types')
        .then(response=>{
            let types_array = [];
            response.data.data.forEach(element => {
                types_array.push({
                    "id" : element.id,
                    "display_name" : element.display_name,
                    "is_stb_type" : element.is_stb_type,
                    "is_create_stb" : element.is_create_stb,
                    "is_create_internet" : element.is_create_internet,
                    "is_remove_stb" : element.is_remove_stb,
                    "is_remove_internet" : element.is_remove_internet,
                    "is_replace_stb" : element.is_replace_stb,
                    "is_replace_internet" : element.is_replace_internet

                })
            });
            this.setState({
                data:types_array
            });
        })
        .catch(err => {
            if(err.response.status === 401){
                logOut(this.props);
            }
        })
    }

    on_fetch_types(data){
        this.setState({
            data:data
        })
    }

    onRowSelectionChange(currentRowsSelected){
        this.setState({
            ...this.state,
            selected_type:this.state.data[currentRowsSelected[0].dataIndex].id,
            response:{
                isInvalid:false,
                isValid:false
            }
        })
    }


    delete(id){
        axiosInstance.delete('/tickets/types/'+id)
        .then(response=>{
            this.fetch_types();
            this.setState({
                response:{
                    ...this.state.response,
                    isValid:true,
                    message:response.data.message
                },
                options:{
                    ...this.state.options,
                    rowsSelected:[]
                },
            })
        })
        .catch(error => {
            if(error.response.status == 422){
                this.on_bad_request(error.response.data);
            }
        });
    }
    on_bad_request(data){
        // message = data.map()
        this.setState({
            response:{
                ...this.state.response,
                isInValid:true,
                message:data.messages
            }
        })
    }


    render(){
        let add_user = null;
        if(containsPermission(this.props.role_permissions,'types.add')){
            add_user = <Link  to = "/types/new_type"  id = "create_new_btn" className="btn btn-dark" > ახლის დამატება</Link>;
        }
        return (
            <div className = "content-main">
                <Form.Row>
                        <Form.Group as={Col}  md="4" >
                            <Form.Control
                                    problem="text"
                                    name="problem"
                                    hidden = {true}
                                    isInvalid = {Boolean(this.state.response.isInValid)}
                                    isValid = {Boolean(this.state.response.isValid)}
                                    onChange = {null}
                                />
                            <Form.Control.Feedback type="invalid" >
                                {this.state.response.message}
                            </Form.Control.Feedback>

                            <Form.Control.Feedback >
                                {this.state.response.message}
                            </Form.Control.Feedback>
                        </Form.Group>
                </Form.Row>
                {add_user}
                <MUIDataTable
                    data={this.state.data}
                    columns={columns}
                    options={this.state.options}
                />
            </div>
        )
    }
}
export default withRouter(Types);